// const features = [
//   {
//     name: 'BetMGM.',
//     description: 'Golf.',
//   },
//   {
//     name: 'NASCAR.',
//     description: '3Wide.',
//   },
//   {
//     name: 'NBA.',
//     description: 'Something about NBA QuickPlay. ',
//   },
// ]

function PickEm() {
    return (
      <div className="overflow-hidden bg-white py-20 sm:py-24" id={"pickem"}>
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <img
              src="/games/pickem.png"
              alt="Product screenshot"
              width={2432}
              height={1442}
              className="order-last lg:order-first"
            />
            <div className="order-first lg:order-last lg:pr-8 lg:pt-4">
              <div className="lg:max-w-lg">
                <p className="text-4xl font-bold tracking-tight text-gray-900 font-serif font-semibold">Pick 'em Games</p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  Pick 'em games involve making one prediction per day or week. Players choose a team, player, or outcome each time, focusing on consistency and strategy over a longer period. These games are popular for casual players looking for a simple, low-pressure format.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default PickEm;
